// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__lQ8EI","container":"style_container__-xD0R","frame":"style_frame__sFor+","content":"style_content__3wQfK"};